import { useState } from 'react'
import type { ImgHTMLAttributes } from 'react'
import Box from '@mui/material/Box'

type Props = Pick<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet' | 'sizes' | 'alt' | 'loading'> & {
  fit?: 'cover' | 'contain'
}

/** Parent reserves the complete image area, including for missing images. */
export default function SearchImage({ src, srcSet, sizes, alt = '', loading = 'eager', fit = 'cover' }: Props) {
  const [failedSource, setFailedSource] = useState<string>()
  return <Box sx={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center', background: '#f5f3ef', overflow: 'hidden' }}>
    {src && failedSource !== src
      ? <Box component='img' src={src} srcSet={srcSet} sizes={sizes} alt={alt}
          width={400} height={fit === 'cover' ? 250 : 400} loading={loading} decoding='async'
          onError={() => setFailedSource(src)}
          sx={{ position: 'absolute', inset: 0, display: 'block', width: '100%', height: '100%', objectFit: fit, ...(fit === 'contain' ? { p: 1 } : {}) }}
        />
      : <Box role='img' aria-label={alt ? `${alt} – Bild nicht verfügbar` : 'Bild nicht verfügbar'} sx={{ color: '#a39b90', display: 'grid', placeItems: 'center' }}>
          <svg width='36' height='36' viewBox='0 0 36 36' fill='none' aria-hidden='true'>
            <rect x='5' y='5' width='26' height='26' rx='5' stroke='currentColor' strokeWidth='1.5' />
            <circle cx='13' cy='13' r='3' stroke='currentColor' strokeWidth='1.5' />
            <path d='m7 27 8-8 5 5 4-4 5 7' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
        </Box>
    }
  </Box>
}
